import classnames from 'classnames';
import React, { useState } from 'react';
import Skeleton from 'react-loading-skeleton';

import TRANSLATIONS from './translations@default.json';

const Image = ({ src, alt, classes, style, skeletonProps, errorSize }) => {
	alt = alt?.substring(0, 100) ?? '';

	const [loaded, setLoaded] = useState(false);
	const [error, setError] = useState(false);

	const isLargeError = errorSize === 'large';
	const isSmallError = errorSize === 'small';

	return (
		<React.Fragment>
			{error && (
				<div
					style={{ ...style }}
					className={classnames(
						'flex items-center justify-center border border-solid border-gray-20 rounded text-title-sm text-center',
						{
							'h-48 p-4': isLargeError,
							'p-1 md:p-2': isSmallError,
						}
					)}>
					{isLargeError ? TRANSLATIONS.errorLarge : TRANSLATIONS.errorSmall}
				</div>
			)}
			{!loaded && !error && <Skeleton {...skeletonProps} style={style} />}
			{!error && (
				<img
					className={classnames(classes, {
						'opacity-0 w-0 h-0': !loaded,
						'opacity-100': loaded,
					})}
					style={style}
					src={src}
					alt={alt}
					onLoad={() => setLoaded(true)}
					onError={() => setError(true)}
				/>
			)}
		</React.Fragment>
	);
};

export default Image;
